import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.admin, routes: [{ path: '/hauling-stats', component: FuseLoadable({ loader: () => import('./HaulingStatsApp') }) }] };

export default [Index];
